import React from 'react';
import Footer from '../../components/footer/Footer';
import StepHeader from '../../components/stepHeader/StepHeader';
import Chat from '../../components/chat/Chat';
import { useTranslate } from '../../../core/translate';
import { useModelInfo } from '../../common/ModelInfoContext';
import { combineClassNames } from '../../../core/css';
import AlternateDriveTypeCheckbox from '../../steps/config/trims/alternateDriveTypeCheckbox/AlternateDriveTypeCheckbox';

const GridView = (props) => {
  const {
    driveTypeFilter,
    step,
    options,
    bottomOffset,
    filterModifier = '',
    filteredOutOption = null,
    gridClassName = null,
  } = props;
  const { hasTransactionId } = useModelInfo();
  const translate = useTranslate();
  const primaryDisclaimer = translate(
    'feature.filter.grid.view.primary.disclaimer.v3'
  );
  const secondaryDisclaimer = translate(
    'feature.filter.grid.view.secondary.disclaimer.v3'
  );

  return (
    <div
      className="gridview__container"
      style={{ paddingBottom: bottomOffset }}>
      <main className="gridview__content-container">
        <StepHeader step={step} />
        {driveTypeFilter && (
          <div
            className={`gridview__filters ${
              filterModifier ? filterModifier : ''
            }`}>
            {driveTypeFilter}
            <AlternateDriveTypeCheckbox />
          </div>
        )}
        <section
          className={combineClassNames(
            'gridview__grid-container',
            gridClassName
          )}
          role="status"
          aria-live="polite"
          aria-relevant="removals">
          {options}
        </section>
        {filteredOutOption && (
          <section
            className="gridview__filtered-out"
            role="status"
            aria-live="polite"
            aria-relevant="removals">
            <div className="gridview__filtered-out__disclaimer">
              <span
                className="gridview__primary-disclaimer"
                dangerouslySetInnerHTML={{ __html: primaryDisclaimer }}
              />
              <span
                className="gridview__secondary-disclaimer"
                dangerouslySetInnerHTML={{ __html: secondaryDisclaimer }}
              />
            </div>
            <div className="gridview__grid-container">{filteredOutOption}</div>
          </section>
        )}
      </main>
      <div className="gridview__footer-section">
        {!hasTransactionId && (
          <div className="gridview__cta-container">
            <Chat />
          </div>
        )}
        <Footer className="gridview__footer" />
      </div>
    </div>
  );
};
export default GridView;
